<template>
    <div>
        <az-back-button :route="{name: 'usuarioBusca'}" text="Voltar para listagem"></az-back-button>
        <az-container>
            <usuario-acoes/>
            <usuario-dados v-model="usuario"/>
        </az-container>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import {actionTypes} from '@/commons/constants'
    import UsuarioAcoes from './acoes/UsuarioAcoes'
    import UsuarioDados from './UsuarioDados'

    export default {
        name: 'Usuario',
        components: {UsuarioAcoes, UsuarioDados},
        computed: {
            ...mapState(['usuario'])
        },
        async mounted() {
            this.setMensagemLoading('Carregando usuário...')
            await this.buscarUsuarioInterno(this.$route.params.id)
        },
        methods: {
            ...mapActions([actionTypes.BUSCAR_USUARIO_INTERNO])
        }
    }
</script>